import React = require("react");
import {ColorUtils} from "../../components/Utils/color/ColorUtils";
import {AppTranslations} from "../../components/Utils/translations/AppTranslations";
import {DashboardConfigurationTexts, WidgetResponse} from "../DashboardContainer";
import {DispenseTimeWidget} from "./lavazza/DispenseTimeWidget";
import {WeeksSalesCompareWidget} from "./lavazza/WeeksSalesCompareWidget";
import {CountsWidget} from "./standard/CountsWidget";
import {EquipmentWidget} from "./standard/EquipmentWidget";
import {ListItem, ListWidget} from "./standard/ListWidget";
import {AlarmsManagementWidget} from "./unilever/AlarmsManagementWidget";
import {AssetBaseDashboardWidget} from "./unilever/AssetBaseDashboardWidget";
import {EquipmentByLevelWidget} from "./unilever/EquipmentByLevelWidget";
import {EquipmentByModelWidget} from "./unilever/EquipmentByModelWidget";
import {EquipmentConnectivityWidget} from "./unilever/EquipmentConnectivityWidget";
import {MarketWidget} from "./unilever/MarketWidget";
import {NotAtManufacturersWidget} from "./unilever/NotAtManufacturersWidget";
import {OpenAlarmsByLevelWidget} from "./unilever/OpenAlarmsByLevelWidget";
import {OpenAlarmsWidget} from "./unilever/OpenAlarmsWidget";

declare var AppTranslations: AppTranslations;

interface DashboardWidgetProps {
    data: WidgetResponse;
    configuration: DashboardConfigurationTexts;
    stackManager: any;
    colorsUtils: ColorUtils;
    hideOnLoading?: boolean;
}

interface DashboardWidgetState {
    width: string;
    widget: any;
    hide: boolean;
}

export const CHART_COLORS = [
    "#c4d0ce",
    "#c3acb2",
    "#9e8f7c",
    "#71252f",
    "#4cc9c5",
    "#c9b04c",
    "#f2d4f7",
    "#86d88e",
    "#ddd35f",
    "#76D7C4",
    "#D7BDE2",
    "#27AE60",
    "#F9E79F",
    "#F5B7B1",
    "#A9CCE3",
    "#F8C471",
    "#85929E",
    "#E74C3C",
];

export class DashboardWidget extends React.Component<DashboardWidgetProps, DashboardWidgetState> {

    constructor(props: DashboardWidgetProps) {
        super(props);
        this.showWidget = this.showWidget.bind(this);
        this.state = {
            width: "standard",
            widget: undefined,
            hide: props.hideOnLoading != null ? props.hideOnLoading : false,
        };

    }

    public componentDidMount() {
        this.setWidgetType();
    }

    public setWidgetType() {
        switch (this.props.data.type) {
            case "EQUIPMENT": {
                this.setState({
                    width: "small",
                    widget: (
                        <EquipmentWidget
                            data={this.props.data}
                            title={this.props.configuration.standard.equipmentDistributionWidgetTitle}
                            stackManager={this.props.stackManager}
                        />
                    ),
                });
                break;
            }
            case "LAST-ALARMS-WIDGET": {
                const onRowClick = (elem: ListItem) => {
                    this.props.stackManager.addNewLevel(
                        "EquipmentDetailLevel",
                        {
                            id: elem.id2,
                            alarmId: elem.id,
                            goTo: "alarms",
                        });
                };
                this.setState({
                    width: "small",
                    widget: (
                        <ListWidget
                            data={this.props.data}
                            title={this.props.configuration.standard.lastAlarmsWidgetTitle}
                            onRowClick={onRowClick}
                            headerClassName={"technical-header"}
                            nextToTitle={(
                                <WidgetBadge type={WidgetBadgeType.TECHNICAL}/>
                            )}
                        />
                    ),
                });
                break;
            }
            case "LAST-ACTIVITIES-WIDGET": {
                const onRowClick = (elem: ListItem) => {
                    this.props.stackManager.addNewLevel("WorkOrderDetailLevel", {id: elem.id});
                };
                this.setState({
                    width: "small",
                    widget: (
                        <ListWidget
                            data={this.props.data}
                            title={this.props.configuration.standard.lastActivitiesWidgetTitle}
                            onRowClick={onRowClick}
                            headerClassName={"technical-header"}
                            nextToTitle={(
                                <WidgetBadge type={WidgetBadgeType.TECHNICAL}/>
                            )}
                        />
                    ),
                });
                break;
            }
            case "ACTIVE-EQUIPMENT-AND-LOCATION": {
                this.setState({
                        width: "small",
                        widget: (
                            <CountsWidget
                                data={this.props.data}
                                title={this.props.configuration.standard.activeEquipmentAndLocationsLastWeekTitle}
                                stackManager={this.props.stackManager}
                                showWidgetFunction={this.showWidget}
                                headerClassName={"commercial-header"}
                                nextToTitle={(
                                    <div className={"badge horizontal-padding-10 commercial-badge"}>
                                        <div className={"div-icon-20"}>
                                            <img
                                                className={"icon-20"}
                                                src={"/vebox/images/misc/ic_person_man_boss.png"}
                                            />
                                        </div>
                                        <p className={"font-size-10 capitalize"}>
                                            {AppTranslations.dashboard.commercial}
                                        </p>
                                    </div>
                                )}
                            />
                        ),
                    },
                );
                break;
            }
            case "ACTIVE-EQUIPMENT-AND-LOCATION-SMALL": {
                this.setState({
                        width: "small",
                        widget: (
                            <CountsWidget
                                data={this.props.data}
                                title={this.props.configuration.standard.activeEquipmentAndLocationsLastWeekTitle}
                                stackManager={this.props.stackManager}
                                showWidgetFunction={this.showWidget}
                                headerClassName={"commercial-header"}
                                nextToTitle={(
                                    <div className={"badge horizontal-padding-10 commercial-badge"}>
                                        <div className={"div-icon-20"}>
                                            <img
                                                className={"icon-20"}
                                                src={"/vebox/images/misc/ic_person_man_boss.png"}
                                            />
                                        </div>
                                        <p className={"font-size-10 capitalize"}>
                                            {AppTranslations.dashboard.commercial}
                                        </p>
                                    </div>
                                )}
                            />
                        ),
                    },
                );
                break;
            }
            case "EQUIPMENT-EFFICIENCY": {
                this.setState({
                        width: "small",
                        widget: (
                            <CountsWidget
                                data={this.props.data}
                                title={this.props.configuration.standard.equipmentEfficiency}
                                stackManager={this.props.stackManager}
                                showWidgetFunction={this.showWidget}
                                headerClassName={"commercial-header"}
                                cardsConfigs={[
                                    {
                                        color: "rgb(252, 89, 77)",
                                        anticlockwise: true,
                                    },
                                    {
                                        color: "rgb(0, 195, 153)",
                                        anticlockwise: false,
                                    },
                                ]}
                                nextToTitle={(
                                    <div className={"badge horizontal-padding-10 commercial-badge"}>
                                        <div className={"div-icon-20"}>
                                            <img
                                                className={"icon-20"}
                                                src={"/vebox/images/misc/ic_person_man_boss.png"}
                                            />
                                        </div>
                                        <p className={"font-size-10 capitalize"}>
                                            {AppTranslations.dashboard.commercial}
                                        </p>
                                    </div>
                                )}
                            />
                        ),
                    },
                );
                break;
            }
            case "EQUIPMENT-STOCK-LEVEL": {
                this.setState({
                        width: "small",
                        widget: (
                            <CountsWidget
                                data={this.props.data}
                                title={this.props.configuration.standard.equipmentStockStatus}
                                stackManager={this.props.stackManager}
                                showWidgetFunction={this.showWidget}
                                headerClassName={"commercial-header"}
                                cardsConfigs={[
                                    {
                                        color: "rgb(252, 89, 77)",
                                        anticlockwise: true,
                                    },
                                    {
                                        color: "rgb(0, 195, 153)",
                                        anticlockwise: false,
                                    },
                                ]}
                                nextToTitle={(
                                    <div className={"badge horizontal-padding-10 commercial-badge"}>
                                        <div className={"div-icon-20"}>
                                            <img
                                                className={"icon-20"}
                                                src={"/vebox/images/misc/ic_person_man_boss.png"}
                                            />
                                        </div>
                                        <p className={"font-size-10 capitalize"}>
                                            {AppTranslations.dashboard.commercial}
                                        </p>
                                    </div>
                                )}
                            />
                        ),
                    },
                );
                break;
            }
            case "DISPENSE-COFFEE-TIME": {
                this.setState({
                    width: "small",
                    widget: (
                        <DispenseTimeWidget
                            title={this.props.configuration.standard.dispenseCoffeeTimeWidgetTitle}
                            data={this.props.data}
                        />
                    ),
                });
                break;
            }
            case "LAST-WEEKS-SALES-COMPARISON-WIDGET": {
                this.setState({
                    width: "sswide",
                    widget: (
                        <WeeksSalesCompareWidget
                            title={this.props.configuration.standard.comparativeCoffeeSalesWidgetTitle}
                            data={this.props.data}
                        />
                    ),
                });
                break;
            }
            case "ASSET-BASE-WIDGET": {
                this.setState({
                    width: "small",
                    widget: (
                        <AssetBaseDashboardWidget
                            texts={this.props.configuration.unilever.assetBase}
                            data={this.props.data}
                            withTelemetryDevice={true}
                            colorGenerator={this.props.colorsUtils}
                        />
                    ),
                });
                break;
            }
            case "NOT-AT-MANUFACTURER-BASE-WIDGET": {
                this.setState({
                    width: "small",
                    widget: (
                        <NotAtManufacturersWidget
                            texts={this.props.configuration.unilever.notAtManufacturers}
                            data={this.props.data}
                            withTelemetryDevice={true}
                            colorGenerator={this.props.colorsUtils}
                        />
                    ),

                });
                break;
            }
            case "MARKET-WIDGET": {
                this.setState({
                    width: "small",
                    widget: (
                        <MarketWidget
                            texts={this.props.configuration.unilever.market}
                            data={this.props.data}
                            withTelemetryDevice={true}
                            colorGenerator={this.props.colorsUtils}
                        />
                    ),
                });
                break;
            }
            case "EQUIPMENT-BY-REGION-WIDGET": {
                this.setState({
                    width: "small",
                    widget: (
                        <EquipmentByLevelWidget
                            texts={this.props.configuration.unilever.placement}
                            data={this.props.data}
                            withTelemetryDevice={true}
                            colorGenerator={this.props.colorsUtils}
                        />
                    ),
                });
                break;
            }
            case "EQUIPMENT-BY-MODEL-WIDGET": {
                this.setState({
                    width: "small",
                    widget: (
                        <EquipmentByModelWidget
                            texts={this.props.configuration.unilever.equipmentTypes}
                            data={this.props.data}
                            withTelemetryDevice={true}
                            colorGenerator={this.props.colorsUtils}
                        />
                    ),
                });
                break;
            }
            case "OPENED-ALARMS-WIDGET": {
                this.setState({
                    width: "sswide",
                    widget: (
                        <OpenAlarmsWidget
                            texts={this.props.configuration.unilever.alarmsOpened}
                            data={this.props.data}
                            colorGenerator={this.props.colorsUtils}
                        />
                    ),
                });
                break;
            }
            case "OPENED-ALARMS-BY-REGION-WIDGET": {
                this.setState({
                    width: "small",
                    widget: (
                        <OpenAlarmsByLevelWidget
                            texts={this.props.configuration.unilever.alarmsDistribution}
                            data={this.props.data}
                            colorGenerator={this.props.colorsUtils}
                        />
                    ),
                });
                break;
            }
            case "ALARMS-MANAGEMENT-WIDGET": {
                this.setState({
                    width: "sswide",
                    widget: (
                        <AlarmsManagementWidget
                            texts={this.props.configuration.unilever.alarmsManagement}
                            data={this.props.data}
                        />
                    ),
                });
                break;
            }
            case "EQUIPMENT-CONNECTIVITY": {
                this.setState({
                    width: "sswide",
                    widget: (
                        <EquipmentConnectivityWidget
                            keyName={this.props.data.dataUrl}
                            texts={this.props.configuration.unilever.equipmentConnectivity}
                            withTelemetryDevice={true}
                        />
                    ),
                });
            }
        }
    }

    public render() {
        let hideMe = {
            display: "none",
        };
        if (!this.state.widget && !this.state.hide) {
            return (<span style={hideMe}/>);
        }
        if (!this.state.hide) {
            hideMe = null;
        }
        const allClassNames: string = `${this.state.width} dashboard-widget f-grid-item`;
        return (
            <div className={allClassNames} style={hideMe}>
                <div className="widget-content">
                    {this.state.widget}
                </div>
            </div>
        );
    }

    private showWidget() {
        this.setState({hide: false});
    }
}

export enum WidgetBadgeType { COMMERCIAL, COMMERCIAL_W, TECHNICAL}

interface WidgetBadgeProps {
    type: WidgetBadgeType;
}

export const WidgetBadge: React.FC<WidgetBadgeProps> = (props) => {
    switch (props.type) {
        case WidgetBadgeType.COMMERCIAL: {
            return (
                <div className={"badge horizontal-padding-10 commercial-badge"}>
                    <div className={"div-icon-20"}>
                        <img
                            className={"icon-20"}
                            src={"/vebox/images/misc/ic_person_man_boss.png"}
                        />
                    </div>
                    <p className={"font-size-10 capitalize"}>{AppTranslations.dashboard.commercial}</p>
                </div>
            );
        }
        case WidgetBadgeType.COMMERCIAL_W: {
            return (
                <div className={"badge horizontal-padding-10 commercial-badge"}>
                    <div className={"div-icon-20"}>
                        <img
                            className={"icon-20"}
                            src={"/vebox/images/misc/ic_person_woman_distributor.png"}
                        />
                    </div>
                    <p className={"font-size-10 capitalize"}>{AppTranslations.dashboard.commercial}</p>
                </div>
            );
        }
        case WidgetBadgeType.TECHNICAL:
        default: {
            return (
                <div className={"badge horizontal-padding-10 commercial-badge"}>
                    <div className={"div-icon-20"}>
                        <img
                            className={"icon-20"}
                            src={"/vebox/images/misc/ic_person_man_technician.png"}
                        />
                    </div>
                    <p className={"font-size-10 capitalize"}>{AppTranslations.dashboard.technical}</p>
                </div>
            );
        }
    }
}